import script from "./springHot.vue?vue&type=script&lang=ts&setup=true"
export * from "./springHot.vue?vue&type=script&lang=ts&setup=true"

import "./springHot.vue?vue&type=style&index=0&id=1562d5ae&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1562d5ae"]])

export default __exports__